import { covers, fields } from "../../../mocks/clueSite";

export default function FieldGrid() {
  return (
    <section id="fields" className="bg-foreground-950 text-background-50">
      <div className="mx-auto max-w-[1280px] px-4 md:px-6 py-12 md:py-16">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4">
          <div>
            <div className="flex items-center gap-2">
              <span className="inline-flex h-6 items-center rounded bg-primary-500 px-2 text-xs font-semibold text-background-50">
                档 案
              </span>
              <h2 className="font-heading text-2xl md:text-4xl font-black text-background-50">分区密档</h2>
            </div>
            <p className="mt-2 text-sm text-background-300/75">
              按题材归档的线报合集，每份密档都配一张封面，点击可下钻查看该分区已核实线索。
            </p>
          </div>
          <span className="hidden lg:flex items-center gap-2 text-xs text-background-300/60">
            <i className="ri-shield-check-line text-accent-400" />
            已通过人工核验的归档线报
          </span>
        </div>

        <div className="mt-7 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {fields.map((f, idx) => (
            <a
              href="#feed"
              key={f.key}
              className="group relative overflow-hidden rounded-lg lift"
              aria-label={`${f.kicker} ${f.name}`}
            >
              <div className="aspect-[4/5] w-full overflow-hidden">
                <img
                  src={covers[idx % covers.length]}
                  alt={`51黑料 ${f.kicker} 分区密档封面`}
                  title={`${f.name} 线报档案`}
                  className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
              </div>
              <div className="absolute inset-0 bg-gradient-to-t from-foreground-950 via-foreground-950/40 to-transparent" />
              <div className="absolute inset-x-0 bottom-0 p-4 md:p-5">
                <div className="flex items-center gap-1.5">
                  <span className="inline-flex items-center rounded bg-accent-500 px-1.5 py-0.5 text-[11px] font-semibold text-foreground-950">
                    {f.kicker}
                  </span>
                  <span className="font-number text-xs text-background-300/70">#{String(idx + 1).padStart(2, "0")}</span>
                </div>
                <h3 className="mt-2 font-heading text-lg md:text-xl font-bold leading-snug text-background-50">{f.name}</h3>
                <p className="mt-1.5 line-clamp-2 text-xs text-background-200/80">{f.desc}</p>
                <ul className="mt-3 hidden sm:flex flex-wrap gap-1.5">
                  {f.items.map((it) => (
                    <li
                      key={it}
                      className="rounded-full border border-background-200/30 bg-background-100/10 px-2 py-0.5 text-[11px] text-background-100"
                    >
                      {it}
                    </li>
                  ))}
                </ul>
                <span className="mt-3 inline-flex items-center gap-1 text-xs font-medium text-accent-300">
                  查看本区线报
                  <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform" />
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}